import * as Types from '@mildang/graphql-artifact';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EventProcessor_StudyModuleInstanceFragment = { __typename?: 'StudyModuleInstance', id: string, feed: { __typename?: 'Feed', id: string, groupId: string } };

export type EventProcessorQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type EventProcessorQuery = { __typename?: 'Query', studyModuleInstanceById: { __typename?: 'StudyModuleInstance', id: string, feed: { __typename?: 'Feed', id: string, groupId: string } } };

export const EventProcessor_StudyModuleInstanceFragmentDoc = gql`
    fragment EventProcessor_StudyModuleInstance on StudyModuleInstance {
  id
  feed {
    id
    groupId
  }
}
    `;
export const EventProcessorDocument = gql`
    query EventProcessor($id: ID!) {
  studyModuleInstanceById(id: $id) {
    id
    ...EventProcessor_StudyModuleInstance @unmask
  }
}
    ${EventProcessor_StudyModuleInstanceFragmentDoc}`;

/**
 * __useEventProcessorQuery__
 *
 * To run a query within a React component, call `useEventProcessorQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventProcessorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventProcessorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventProcessorQuery(baseOptions: Apollo.QueryHookOptions<EventProcessorQuery, EventProcessorQueryVariables> & ({ variables: EventProcessorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventProcessorQuery, EventProcessorQueryVariables>(EventProcessorDocument, options);
      }
export function useEventProcessorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventProcessorQuery, EventProcessorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventProcessorQuery, EventProcessorQueryVariables>(EventProcessorDocument, options);
        }
export function useEventProcessorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventProcessorQuery, EventProcessorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventProcessorQuery, EventProcessorQueryVariables>(EventProcessorDocument, options);
        }
export type EventProcessorQueryHookResult = ReturnType<typeof useEventProcessorQuery>;
export type EventProcessorLazyQueryHookResult = ReturnType<typeof useEventProcessorLazyQuery>;
export type EventProcessorSuspenseQueryHookResult = ReturnType<typeof useEventProcessorSuspenseQuery>;
export type EventProcessorQueryResult = Apollo.QueryResult<EventProcessorQuery, EventProcessorQueryVariables>;
export const namedOperations = {
  Query: {
    EventProcessor: 'EventProcessor'
  },
  Fragment: {
    EventProcessor_StudyModuleInstance: 'EventProcessor_StudyModuleInstance'
  }
}